import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Icon,
  Text,
  Box,
  Row,
  Col,
  ButtonIcon,
} from '@cubeyou-team/hx-react-components';
import classNames from 'classnames';

import { getItemIcon } from 'src/utils';
import { APPS_MAP, PRODUCTS_ICONS } from 'src/constants/config';
import { removeApplicationDroppingEntity } from 'src/actions';
import { getCurrentProductDataSources } from 'src/selectors/myCompany';
import { StyledDroppingEntity } from './StyledAudienceOpener';
import CompareAudienceOpenerActions from './CompareAudienceOpenerActions';

const AudienceOpenerContent = ({ app, isDisabled, isDropping }) => {
  const dispatch = useDispatch();
  const productDataSources = useSelector(state =>
    getCurrentProductDataSources(state)
  );
  const droppingEntities = useSelector(
    state => state.repository.droppingEntities
  );

  const variant = useMemo(() => {
    if (isDisabled) return 'dark';
    if (isDropping) return 'primary';
    return 'dark';
  }, [isDisabled, isDropping]);

  if (droppingEntities?.[app.name]?.length > 0) {
    return (
      <Box style={{ height: '100%', width: '80%', pointerEvents: 'visible' }}>
        {droppingEntities[app.name].map((entity, index) => {
          const icon = getItemIcon(entity, productDataSources);
          return (
            <Box
              pB="small"
              key={`dropping-entity-${app.id}-${index}`}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pointerEvents: 'visible',
              }}
            >
              <StyledDroppingEntity appName={app.name}>
                <Row valign="middle" halign="between" style={{ width: '100%' }}>
                  <Col span={2}>
                    <Icon
                      size="small"
                      icon={icon}
                      variant={isDropping ? 'light' : 'dark'}
                    />
                  </Col>
                  <Col span={8}>
                    <Text
                      size="small"
                      title={entity.label}
                      variant={isDropping ? 'light' : 'dark'}
                      className={classNames(
                        'overflow-hidden text-ellipsis whitespace-nowrap w-full'
                      )}
                    >
                      {entity.label}
                    </Text>
                  </Col>
                  <Col
                    span={2}
                    style={{ display: 'flex', justifyContent: 'end' }}
                  >
                    <ButtonIcon
                      size="xsmall"
                      icon="remove"
                      variant="light"
                      onClick={e => {
                        e.stopPropagation();
                        dispatch(
                          removeApplicationDroppingEntity(entity.id, app.name)
                        );
                      }}
                    />
                  </Col>
                </Row>
              </StyledDroppingEntity>
            </Box>
          );
        })}
        {app.name === APPS_MAP.COMPARE && (
          <CompareAudienceOpenerActions entities={droppingEntities[app.name]} />
        )}
      </Box>
    );
  }

  return (
    <>
      <Icon variant={variant} icon={PRODUCTS_ICONS[app.name]} size="xxlarge" />
      <Box pY="medium">
        <Text
          align="center"
          lettercase="uppercase"
          size="xheadline"
          variant={variant}
          weight="bold"
        >
          {app.title}
        </Text>
      </Box>
      <Text
        align="center"
        style={{ whiteSpace: 'pre-wrap' }}
        variant={!isDisabled ? 'dark' : 'light_darker_1'}
      >
        {app.description}
      </Text>
      <Text
        align="center"
        style={{ whiteSpace: 'pre-wrap' }}
        variant={!isDisabled ? 'secondary' : 'light_darker_1'}
        weight="bold"
      >
        {app.defaultExample}
      </Text>
    </>
  );
};

export default AudienceOpenerContent;
